const BACK_TO_TOP_SELECTOR = '#top-link-block';

export default function _backToTop() {
    const backToTop = document.querySelector(BACK_TO_TOP_SELECTOR);

    function toggleBackToTop() {
        if (document.body.scrollTop < 100) {
            backToTop.classList.add('hide');
        } else {
            backToTop.classList.remove('hide');
        }
    }

    function scrollToTop() {
        const scrollDuration = 250;
        const scrollStep = -document.body.scrollTop / (scrollDuration / 15);

        const scrollInterval = setInterval(() => {
            if (document.body.scrollTop !== 0) {
                document.body.scrollBy(0, scrollStep);
            } else {
                clearInterval(scrollInterval);
            }
        }, 15);
    }

    if (backToTop) {
        toggleBackToTop();
        document.body.addEventListener('scroll', () => {
            toggleBackToTop();
        });
        backToTop.addEventListener('click', () => {
            scrollToTop();
        });
    }
}

_backToTop();
